import React from 'react';
import TextWithTooltip from '../../../../components/text-with-tooltip';
import { Desktop, Mobile } from '../../../../app-responsive';

const BSIPMigrationTable = (props) => {
  const { siteServicesArray, bsipServiceDetails } = props;

  const getServiceTypeText = (type) => {
    switch (type) {
      case 'GDN':
        return bsipServiceDetails.gdnText;
      case 'PrimaryFNN' :
        return bsipServiceDetails.primaryFNN;
      default:
        return bsipServiceDetails.auxillary;
    }
  };

  const desktopMigrationTable = siteServicesArray.map(service => (
    <div key={service.number} className="row bsip-migrate-row">
      <div className={`col-3 ${service.type.toLowerCase()}`}> {getServiceTypeText(service.type)} </div>
      <div className="col-3">{service.number}</div>
      <div className="col-6"> {bsipServiceDetails.migrateToBsipText} </div>
    </div>
  ));

  const mobileMigrationTable = siteServicesArray.map(service => (
    <div key={service.number} className="row bsip-migrate-row">
      <div className={`col-12 ${service.type.toLowerCase()}`}> {getServiceTypeText(service.type)} </div>
      <div className="col-6 migrate-fnn-mobile-col"><strong>{bsipServiceDetails.fnnHeadingText}</strong></div>
      <div className="col-6 migrate-fnn-mobile-col"> <strong>{bsipServiceDetails.actionHeadingText} </strong></div>
      <div className="col-6 migrate-fnn-mobile-col-data">{service.number}</div>
      <div className="col-6 migrate-fnn-mobile-col-data"> {bsipServiceDetails.migrateToBsipText} </div>
    </div>
  ));

  return (
    <div className="serviceTable">
      <div className="row headings hidden-mobile">
        <div className="col-6"><h2>{bsipServiceDetails.currentServicesText}</h2></div>
        <div className="col-6"><h2>{bsipServiceDetails.confirmOrderText}</h2></div>
      </div>
      <div className="row column-headings hidden-mobile">
        <div className="col-3">
          <TextWithTooltip
            labelText={bsipServiceDetails.typeHeadingText}
            text={<i className="td-icon icon-help" />}
            textClassName="help-icon-container"
            id="isdn-migration-table-type-tooltip"
            toolTipText={bsipServiceDetails.typeTooltipText}
          />
        </div>
        <div className="col-3">{bsipServiceDetails.fnnHeadingText}</div>
        <div className="col-6">{bsipServiceDetails.actionHeadingText}</div>
      </div>
      <Desktop>
        {desktopMigrationTable}
      </Desktop>
      <Mobile>
        {mobileMigrationTable}
      </Mobile>
    </div>
  );
};

export default BSIPMigrationTable;
